import Vue from 'vue'
import pgDialog from './src/message-box.vue'
import { isVNode } from '../../utils/index'

const DialogConstructor = Vue.extend(pgDialog)

let instance
const instances = []
let seed = 1

export function pgMessageBox(options) {
  instance = new DialogConstructor()
  instance.id = `message_box_${seed++}`
  if (typeof options === 'string') {
    options = {
      message: options,
    }
  } else if (isVNode(options.message)) {
    instance.$slots.default = [options.message]
    options.message = null
  }
  if (options.title && isVNode(options.title)) {
    instance.$slots.title = [options.title]
    options.title = null
  }
  if (options.footer && isVNode(options.footer)) {
    instance.$slots.footer = [options.footer]
    options.footer = null
  }
  options.close = function () {
    pgMessageBox.close(instance.id)
  }
  instance.$mount()
  document.body.appendChild(instance.$el)
  instance.show(options)
  instances.push(instance)
  return instance
}

pgMessageBox.close = function (id) {
  const index = instances.findIndex((ins) => ins.id === id)
  if (index > -1) {
    instances.splice(index, 1)
  }
}

/**
 * promise方式调用
 * @param {object} options
 * @param {string} options.title
 * @param {string} options.message
 * @param {string} options.width
 * @param {string} options.cacelText
 * @param {string} options.confirmText '确 认'
 * @param {string} options.secoundConfirmText
 * @returns {Promise} {onClose, type: ''/'secoundConfirm'/'confirm'}
 */
export function pgMessageBoxAsync(options) {
  return new Promise((resolve) => {
    if (typeof options === 'string') {
      options = {
        message: options,
      }
    }
    pgMessageBox({
      ...options,
      async beforeClose(onClose, type) {
        if (options.beforeClose) {
          await options.beforeClose(onClose, type)
        }
        resolve({ onClose, type })
      },
    })
  })
}
